x
<template>
	<div class="gem-offers-section">
		<div
			class="gem-offers-section__content"
			:class="{
				['gem-offers-section__content--sale']: isOnSale,
			}"
		>
			<BidirectionalTextLabel
				v-if="isOnSale"
				:text="translate('resource.gems')"
				:theme="isOnSale ? LabelThemes.DARK_RED : LabelThemes.RED"
				class="rewards-label"
			/>
			<div
				ref="gems"
				class="offers"
				:data-section-key="ResourceType.GEMS"
			>
				<GridOfferShopItem
					v-for="offer in gemOffers"
					:offer="offer"
					:key="offer.name"
				/>
			</div>
		</div>
		<PaperSection v-if="isOnSale" slug="shop" />
	</div>
</template>

<script lang="ts" setup>
import BidirectionalTextLabel from "@/components/BidirectionalTextLabel.vue";
import GridOfferShopItem from "@/components/shop/cards/GridOfferShopItem.vue";
import PaperSection from "@/components/SVG/PaperSection.vue";
import { ResourceType } from "@/game/entities/config/resources";
import useShopStore from "@/store/useShopStore";
import { LabelThemes } from "@/types/ui";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";

const shopStore = useShopStore();
const { gemOffers } = storeToRefs(shopStore);

interface Props {
	isOnSale: boolean;
}

const { isOnSale } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.gem-offers-section {
	position: relative;
	margin-top: 2rem;
	margin-bottom: 1rem; // IMPORTANT
	width: 100%;

	&__btn {
		position: absolute;
		z-index: 2;

		box-shadow: inset 0 0 0.5rem 0 rgba(0, 0, 0, 0.3);
		border-width: 0.075rem;
		border-style: solid;
		border-image-source: linear-gradient(to top, #bd9032, #f0d386);
		border-image-slice: 1;
		background-image: linear-gradient(to top, #181a1d, #303239);

		&--visibility {
			top: -0.75rem;
			left: -0.25rem;
		}

		&--close {
			top: -0.75rem;
			right: -0.25rem;
		}
	}

	&__cta {
		margin-top: 0.125rem;
		color: #372615;
		text-align: center;
	}

	&__content {
		position: relative;
		z-index: 1;
		width: 100%;

		.offers {
			@include flex-row-center;
			flex-wrap: wrap;
			gap: 1rem;
			margin-top: 0;
		}

		&--sale {
			padding: 0 0.25rem;

			.offers {
				margin-top: 0.75rem;
			}

			:deep(.pack--promo-highlighted) {
				background: linear-gradient(
					0deg,
					rgba(72, 32, 125, 1) 0%,
					rgba(123, 186, 202, 1) 100%
				);
			}
		}

		.bidirectional-text-label {
			position: relative;
			margin: 0 auto;
			margin-top: -1rem;
			width: calc(100% - 9rem);
			height: 2.125rem;
		}

		.timer {
			margin-top: 0.75rem;
			color: #f2dcb5;
		}
	}
}
</style>
